<script>
/* eslint-disable camelcase */
import {
  get_kakao_token,
  get_kakao_login_data,
  check_kakao_login
} from '../../ETC/Axios'

export default {
  name: 'KaKaoLogin',
  mounted () {
    const code = new URL(window.location.href).searchParams.get('code')
    get_kakao_token(code)
      .then((result) => {
        return get_kakao_login_data(result)
      })
      .then((result_login_data) => {
        return check_kakao_login(
          result_login_data.id,
          result_login_data.kakao_account.email,
          result_login_data.properties.nickname
        )
      })
      .then((check_data) => {
        if (check_data.customer_join_level === 1) {
          window.location.href = `/Join?customer_ID=${check_data.customer_ID}&customer_name=${check_data.customer_name}&customer_email=${check_data.customer_email}`
        } else {
          alert('로그인이 완료되었습니다.')
          this.$router.push('/')
        }
      })
      .catch((error) => {
        console.error('에러:', error)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/KaKaoLogin.vue